export var ClientLogLevel;
(function (ClientLogLevel) {
    ClientLogLevel[ClientLogLevel["Unknown"] = 0] = "Unknown";
    ClientLogLevel[ClientLogLevel["Debug"] = 1] = "Debug";
    ClientLogLevel[ClientLogLevel["Info"] = 2] = "Info";
    ClientLogLevel[ClientLogLevel["Warn"] = 4] = "Warn";
    ClientLogLevel[ClientLogLevel["Error"] = 8] = "Error";
    ClientLogLevel[ClientLogLevel["Fatal"] = 16] = "Fatal";
})(ClientLogLevel || (ClientLogLevel = {}));
;
